import React, { useLayoutEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

const HeaderCell = ({ cell, style, extraClasses, children, cellIndex, onHandleSort, sortable, syncDimensions }) => {
  const targetRef = useRef()

  const cellIndexNum = cellIndex && parseInt(cellIndex, 10)

  useLayoutEffect(() => {
    if (targetRef.current && !children) {
      syncDimensions({ dimension: { width: targetRef.current.style.width || `${targetRef.current.offsetWidth}px` }, cell })
    }
  }, [cell])

  return (
    <div
      ref={targetRef}
      onClick={() => {
        if (sortable && cell.sortable) {
          onHandleSort(cell)
        }
      }}
      className={classnames({
        'fil-table--header-cell': !extraClasses,
        [extraClasses]: extraClasses,
        [cell && cell.extraClasses]: cell && cell.extraClasses,
        'fil-table--header-sortable': sortable && cell.sortable,
        [`sorted-${cell.sortOrder}`]: sortable && cell.sortOrder
      })}
      style={style}
    >
      {children || (
        <React.Fragment>
          {sortable && cell.sortable && cellIndexNum !== 0 && (
            <span className="fil-table--header-cell-sort">
              <fil-icon class="fil-table--header-cell-sort-asc" size="16" icon="custom-arrow-up" />
              <fil-icon class="fil-table--header-cell-sort-desc" size="16" icon="custom-arrow-down" />
            </span>
          )}
          <span>{cell.title}</span>
          {sortable && cell.sortable && cellIndexNum === 0 && (
            <span className="fil-table--header-cell-sort">
              <fil-icon class="fil-table--header-cell-sort-asc" size="16" icon="custom-arrow-up" />
              <fil-icon class="fil-table--header-cell-sort-desc" size="16" icon="custom-arrow-down" />
            </span>
          )}
        </React.Fragment>
      )}
    </div>
  )
}

HeaderCell.propTypes = {
  cell: PropTypes.object,
  extraClasses: PropTypes.string,
  children: PropTypes.any,
  cellIndex: PropTypes.string,
  style: PropTypes.object,
  onHandleSort: PropTypes.func,
  sortable: PropTypes.bool,
  syncDimensions: PropTypes.func
}

HeaderCell.defaultProps = {
  extraClasses: '',
  cell: {},
  children: null,
  cellIndex: '',
  style: {},
  onHandleSort: () => {},
  sortable: false,
  syncDimensions: () => {}
}

export default HeaderCell
